import { render } from "./NotificationPage.vue?vue&type=template&id=37c7180e"
import script from "./NotificationPage.vue?vue&type=script&lang=js"
export * from "./NotificationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__